import React from "react";

const videoElement = document.createElement("video");

function invertVideo() {
  videoElement.classList.toggle("invert");
}

class Video extends React.Component {
  constructor(props) {
    super(props);
    this.myVideoContainer = React.createRef();
  }

  componentDidMount() {
    this.myVideoContainer.current.appendChild(videoElement);
  }

  render() {
    return <div ref={this.myVideoContainer} />;
  }
}

export { videoElement, Video, invertVideo };
